import React from 'react';
import peterPortrait from '../assets/peter-avatar.jpg';
import peterIcon from '../assets/peter-icon.png';

/**
 * Peter, in two sizes of the same real artwork — no hand-traced stand-in for either.
 *
 * `PeterPortrait` is the larger crop, used where he's introduced (the welcome state) and at a size
 * where the detail survives.
 *
 * `PeterMark` is a second, separately-cropped piece of art (a flat, pre-simplified render) rather
 * than a shrunk copy of the portrait, which turns to mud below ~60px. Reactions (thinking, error)
 * are done in CSS on the image itself — tilt, a pulsing ring — since there's no internal SVG
 * geometry left to animate.
 */

export function PeterMark({ size = 32, state = 'idle', title }) {
  return (
    <img
      className={`peter-mark peter-mark--${state}`}
      src={peterIcon}
      width={size}
      height={size}
      alt={title || ''}
      role={title ? 'img' : 'presentation'}
      aria-hidden={title ? undefined : true}
      draggable={false}
    />
  );
}

export function PeterPortrait({ size = 96, alt = 'Peter the Project Monkey' }) {
  return (
    <img
      className="peter-portrait"
      src={peterPortrait}
      width={size}
      height={size}
      alt={alt}
      draggable={false}
    />
  );
}

export default PeterMark;
